import { UserApprovalSettingsModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

const defaultCompanyUserApprovalSettings: UserApprovalSettingsModelDto = {
    id: 0,
    backOfficeApproveBackOffice: false,
    channelApproveBackOffice: false,
    channelApproveChannel: false,
};

export class CompanyUserApprovalSettings extends DomainEntity<UserApprovalSettingsModelDto> {
    public get id() {
        return this.dto.id;
    }

    public get backOfficeApproveBackOffice() {
        return this.dto.backOfficeApproveBackOffice;
    }

    public set backOfficeApproveBackOffice(value: boolean) {
        this.dto.backOfficeApproveBackOffice = value;
    }

    public get channelApproveBackOffice() {
        return this.dto.channelApproveBackOffice;
    }

    public set channelApproveBackOffice(value: boolean) {
        this.dto.channelApproveBackOffice = value;
    }

    public get channelApproveChannel() {
        return this.dto.channelApproveChannel;
    }

    public set channelApproveChannel(value: boolean) {
        this.dto.channelApproveChannel = value;
    }

    public createDefault(): this {
        return new CompanyUserApprovalSettings(defaultCompanyUserApprovalSettings) as this;
    }
}
